import React from "react"
import { CopyToClipboard } from "react-copy-to-clipboard"
import { SAMLConfigurationShape } from "utils/propTypeShapes"
import { TertiaryButton } from "shared/buttons"
import SAMLConfigurationsListItemSection from "./SAMLConfigurationsListItemSection"

const SAMLConfigurationsListItemServiceProviderMetadataSection = ({ configuration }) => {
  const { metadataURL } = configuration

  return (
    <SAMLConfigurationsListItemSection title="Service Provider Metadata URL">
      <div className="flex flex-col gap-8 sm:gap-4 w-full">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 min-w-0">
          <span className="grow truncate w-full font-mono">{metadataURL}</span>
          <CopyToClipboard text={metadataURL}>
            <TertiaryButton ariaLabel="copy url" text="Copy" className="shrink-0 w-full sm:w-auto bg-white" />
          </CopyToClipboard>
        </div>
        <p className="text-xs text-dark">
          This URL serves our service provider metadata for this SAML configuration
          as an XML document that provides an identity provider with connection settings
          and security keys.
        </p>
      </div>
    </SAMLConfigurationsListItemSection>
  )
}

SAMLConfigurationsListItemServiceProviderMetadataSection.propTypes = {
  configuration: SAMLConfigurationShape.isRequired,
}

export default SAMLConfigurationsListItemServiceProviderMetadataSection
